import { logEvent as firebaseLogEvent } from 'firebase/analytics';
import { analytics } from "../config/firebase";
export function logEvent(event, eventParams) {
    firebaseLogEvent(analytics, event, eventParams);
}
